// 家庭网关
import React, { useState }  from 'react';
import { Menu } from 'antd';
import IPConfigPage from './IPConfigPage';
import { ServerPageDecoration } from './ServerPageDecoration';
import { AP } from './AP';
import { DHCPApplication } from './DHCPApplication';

export const HomeGateway = (props) => {
    const { node, device } = props;
    const [menuData, setMenuData] = useState('LAN')

    return (
        <ServerPageDecoration paddingTop={0}>
            <Menu onClick={(e) => setMenuData(e.key)} selectedKeys={[menuData]} defaultSelectedKeys={['WAN']} mode="horizontal" style={{background: '#ECF3FA',}}>
                <Menu.Item key="LAN" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}>
                    LAN
                </Menu.Item>
                <Menu.Item key="WAN" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    marginTop: '10px'
                    }}>
                    WAN
                </Menu.Item>
                <Menu.Item key="DHCP" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    marginTop: '10px'
                    }}>
                    DHCP服务
                </Menu.Item>
                <Menu.Item key="AP" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    marginTop: '10px'
                    }}>
                    无线网络
                </Menu.Item>
            </Menu>
            <hr style={{width: '600px',height: '2px',background: '#D5DDE5',}}></hr>
            { menuData === 'LAN' ? (<IPConfigPage node={node} mode="router" device={ device.getLan() } onSubmit={device.onConfigChange} />) : null }
            { menuData === 'WAN' ? (<IPConfigPage node={node} device={ device.getWan() } onSubmit={device.onConfigChange} />) : null }
            { menuData === 'DHCP' ? (<DHCPApplication node={node} device={ device.getDHCP() } onSubmit={device.onConfigChange} />) : null }
            { menuData === 'AP' ? (<AP node={node} device={ device.getAP() } border={false} onSubmit={device.onConfigChange} />) : null }
        </ServerPageDecoration>
    )
}